import cx from 'clsx';

import { DateInputOverrideClassNames } from '../dateinput';
import { InputStyleProps } from '../types';

import datePickerInputClasses from './DatePickerInput.module.css';

export const DatePickerInputOverrideClassNames = (props: InputStyleProps) => {
  const dateInputClasses = DateInputOverrideClassNames(props);

  return {
    ...dateInputClasses,
    input: cx(dateInputClasses.input, datePickerInputClasses.input, {
      [datePickerInputClasses.inputWithDays]: props.largeRightSection
    }),
    section: cx(dateInputClasses.section, {
      [datePickerInputClasses.section]: props.largeRightSection
    })
  };
};
